import { useNavigate } from 'react-router-dom';
import { useHasPermission } from '@/hooks/use-has-permission';
import { HRM_PERMISSIONS } from '@/constant/hr/permissions';
import { SERVICE_DESK_URLS } from '@/modules/service-desk/shared/service-desk.constants';
import { ServiceDeskPageShell } from '@/modules/service-desk/shared/components/service-desk-page-shell';
import { ByodMyApplications } from '../../components/byod-my-applications/byod-my-applications';
import { ByodRequests } from '../../components/byod-requests/byod-requests';

export const ByodPage = () => {
  const navigate = useNavigate();
  const canViewRequests = useHasPermission(HRM_PERMISSIONS.BYOD_APPLICATION.VIEW_REQUESTS);
  const canApply = useHasPermission(HRM_PERMISSIONS.BYOD_APPLICATION.APPLY);

  return (
    <ServiceDeskPageShell
      titleKey="BYOD_TITLE"
      requestsTabKey="BYOD_REQUESTS"
      canViewRequests={canViewRequests}
      requests={<ByodRequests />}
      mine={<ByodMyApplications />}
      onApply={canApply ? () => navigate('/hr/service-desk/byod/apply') : undefined}
      policyUrl={SERVICE_DESK_URLS.devicePolicy}
    />
  );
};
